module.exports = __webpack_public_path__ + "static/media/background.db1e68e0.png";